import React, { useState, useEffect, useRef } from 'react';
import { apiFetch } from './api';
import { useDashboardStats } from './DashboardStatsContext';
import { Editor } from '@tinymce/tinymce-react';

// 🔧 PLACEHOLDER GLOBALI - SEMPRE DISPONIBILI (singola graffa come gli altri)
const GLOBAL_PLACEHOLDERS = [
  '{DATA_ODIERNA}', 
  '{IMMAGINE_INTESTAZIONE}',
  '{IMMAGINE_FONDO}',
  '{FIRMA_ANUTEL}'
];

// Modale semplice Bootstrap-like
function PreviewModal({ show, onClose, subject, content, provider, testMode, testEmails, sendCopy, copyEmails, attachments, emailCount }) {
  if (!show) return null;

  return (
    <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="fas fa-eye"></i> Anteprima Email</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <strong>Oggetto:</strong> {subject || <span className="text-muted">(vuoto)</span>}
            </div>
            <div className="mb-3">
              <strong>Contenuto:</strong>
              <div className="border rounded p-2 bg-light" style={{maxHeight: '200px', overflow: 'auto'}} dangerouslySetInnerHTML={{__html: content || '<span class="text-muted">(vuoto)</span>'}}></div>
            </div>
            <div className="mb-3">
              <strong>Provider SMTP:</strong> {provider || 'Automatico'}
            </div>
            <div className="mb-3">
              <strong>Modalità Test:</strong> {testMode ? 'Sì' : 'No'}
              {testMode && <><br/><strong>Email Test:</strong> {testEmails || <span className="text-muted">(vuoto)</span>}</>}
            </div>
            <div className="mb-3">
              <strong>Invia copia CC:</strong> {sendCopy ? 'Sì' : 'No'}
              {sendCopy && <><br/><strong>Email CC:</strong> {copyEmails || <span className="text-muted">(vuoto)</span>}</>}
            </div>
            <div className="mb-3">
              <strong>Allegati:</strong> {attachments && attachments.length > 0 ? (
                <ul>{Array.from(attachments).map((f,i) => <li key={i}>{f.name}</li>)}</ul>
              ) : <span className="text-muted">Nessuno</span>}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Chiudi</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Modale progress invio
function SendProgressModal({ show, onClose, onCancel, progress, sending }) {
  if (!show) return null;
  
  return (
    <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-paper-plane"></i> Invio Email in Corso
            </h5>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center mb-4">
              <div className="spinner-border text-primary me-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="flex-grow-1">
                <h6 className="mb-2">Invio in corso...</h6>
                <div className="progress mb-2" style={{height: '6px'}}>
                  <div 
                    className="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                    role="progressbar" 
                    style={{width: '100%'}}
                  ></div>
                </div>
                <div className="text-muted small">
                  {progress || 'Preparazione invio...'}
                </div>
              </div>
            </div>
            
            <div className="alert alert-info mb-0">
              <i className="fas fa-info-circle me-2"></i>
              L'invio è in corso. Mantieni aperta questa finestra fino al completamento.
              <br/>
              <small className="text-muted">
                Il processo potrebbe richiedere diversi minuti a seconda del numero di email e della dimensione dei batch.
                <br/>
                <strong>Timeout automatico:</strong> Ogni batch ha un timeout dinamico (2-30 minuti) basato sulla dimensione.
              </small>
            </div>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-danger"
              onClick={onCancel}
              disabled={!sending}
            >
              <i className="fas fa-stop me-1"></i> 
              {sending ? 'Annulla Invio' : 'Annullamento...'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Modale risultato invio
function SendResultModal({ show, onClose, result, error, partialError }) {
  if (!show) return null;
  return (
    <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><i className="fas fa-paper-plane"></i> Esito Invio Email</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {partialError && result ? (
              <>
                <div className="alert alert-warning">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  <strong>Invio interrotto</strong> — {partialError}
                </div>
                <div className="mb-2"><strong>Servizio:</strong> {result.servizio}</div>
                <div className="mb-2"><strong>Oggetto:</strong> {result.oggetto}</div>
                <div className="mb-2"><strong>Data Invio:</strong> {result.dataInvio}</div>
                <div className="mb-2">
                  <strong>Inviate con successo:</strong> <span className="text-success">{result.inviRiusciti}</span> &nbsp;
                  <strong>Fallite:</strong> <span className="text-danger">{result.inviFalliti}</span>
                </div>
                {result.note && (
                  <div className="mb-2"><strong>Note:</strong> <small className="text-muted">{result.note}</small></div>
                )}
                {result.emails && result.emails.length > 0 && (
                  <div className="mb-3">
                    <strong>Dettaglio invii (parziale):</strong>
                    <div style={{maxHeight: '300px', overflow: 'auto'}}>
                      <ul className="list-group">
                        {result.emails.map((e,i) => (
                          <li key={i} className={`list-group-item d-flex flex-column flex-md-row justify-content-between align-items-md-center ${e.esito ? 'list-group-item-success' : 'list-group-item-danger'}`}>
                            <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                              <span><i className={`fas fa-${e.esito ? 'check' : 'times'}`}></i> {e.indirizzo}</span>
                              {e.provider && (
                                <span className="badge bg-info text-dark ms-md-2"><i className="fas fa-server me-1"></i> {e.provider}</span>
                              )}
                            </div>
                            <span>{e.messaggio}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </>
            ) : error ? (
              <div className="alert alert-danger">{error}</div>
            ) : result && result.accodato ? (
              <>
                <div className="alert alert-info">
                  <i className="fas fa-clock me-2"></i>
                  <strong>Email accodate — invio in background</strong>
                </div>
                <div className="mb-2"><strong>Servizio:</strong> {result.servizio}</div>
                <div className="mb-2"><strong>Oggetto:</strong> {result.oggetto}</div>
                <div className="mb-2"><strong>Data:</strong> {result.dataInvio}</div>
                <div className="mb-2"><strong>Email in coda:</strong> <span className="text-primary fw-bold">{result.totalEmails}</span></div>
                <div className="alert alert-light mt-3 mb-0">
                  <i className="fas fa-info-circle me-2 text-muted"></i>
                  <small>L'invio procede automaticamente in background. Puoi chiudere questa finestra.</small>
                </div>
                {result.jobId && (
                  <div className="mt-2"><small className="text-muted">Job ID: {result.jobId}</small></div>
                )}
              </>
            ) : result ? (
              <>
                <div className="mb-2"><strong>Servizio:</strong> {result.servizio}</div>
                <div className="mb-2"><strong>Oggetto:</strong> {result.oggetto}</div>
                <div className="mb-2"><strong>Data Invio:</strong> {result.dataInvio}</div>
                <div className="mb-2"><strong>Inviate con successo:</strong> <span className="text-success">{result.inviRiusciti}</span> &nbsp; <strong>Fallite:</strong> <span className="text-danger">{result.inviFalliti}</span></div>
                {result.note && (
                  <div className="mb-2"><strong>Note:</strong> <small className="text-muted">{result.note}</small></div>
                )}
                <div className="mb-3">
                  <strong>Dettaglio invii:</strong>
                  <div style={{maxHeight: '300px', overflow: 'auto'}}>
                    <ul className="list-group">
                      {result.emails && result.emails.map((e,i) => (
                        <li key={i} className={`list-group-item d-flex flex-column flex-md-row justify-content-between align-items-md-center ${e.esito ? 'list-group-item-success' : 'list-group-item-danger'}`}>
                          <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                            <span><i className={`fas fa-${e.esito ? 'check' : 'times'}`}></i> {e.indirizzo}</span>
                            {e.provider && (
                              <span className="badge bg-info text-dark ms-md-2"><i className="fas fa-server me-1"></i> {e.provider}</span>
                            )}
                          </div>
                          <span>{e.messaggio}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </>
            ) : <div>Invio in corso...</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Chiudi</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ComposizioneMail({ destinatariCount, emailCount, servizio = 'Comunicati', placeholders = [], selectedRows = [], iniziativaData = null, onSendComplete = null }) {
  const { refreshStats } = useDashboardStats();
  
  // Stati per i campi principali
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [templateCategory, setTemplateCategory] = useState('');
  const [templateTag, setTemplateTag] = useState('');

  // Stati per il sistema di template
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [showSaveTemplate, setShowSaveTemplate] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [templateDescription, setTemplateDescription] = useState('');

  // Stati per le opzioni di invio
  const [hasAttachments, setHasAttachments] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [provider, setProvider] = useState('');
  const [testMode, setTestMode] = useState(false);
  const [testEmails, setTestEmails] = useState('');
  const [sendCopy, setSendCopy] = useState(false);
  const [copyEmails, setCopyEmails] = useState('');

  // Provider SMTP dinamici
  const [availableProviders, setAvailableProviders] = useState([]);
  const [loadingProviders, setLoadingProviders] = useState(true);

  // Stati per modali e invio
  const [showPreview, setShowPreview] = useState(false);
  const [showSendProgress, setShowSendProgress] = useState(false);
  const [showSendResult, setShowSendResult] = useState(false);
  const [sendResult, setSendResult] = useState(null);
  const [sendError, setSendError] = useState(null);
  const [sendPartialError, setSendPartialError] = useState(null);
  const [sending, setSending] = useState(false);
  const [sendingProgress, setSendingProgress] = useState('');

  // STATO PER CONTROLLO ANNULLAMENTO
  const [shouldContinue, setShouldContinue] = useState(true);

  // Ref per editor
  const editorDomRef = useRef(null);

  // Funzioni per template
  const loadTemplates = async () => {
    try {
      // 🔧 DETERMINA IL TAG DALLA ROUTE/URL CORRENTE - TUTTE LE 7 SEZIONI
      let currentTag = '';
      
      // Logica per determinare la sezione/tag dalla route corrente
      const currentPath = window.location.pathname;
      
      if (currentPath.includes('/personalizzato') || currentPath.includes('personalizzato')) {
        currentTag = 'personalizzato';
      } else if (currentPath.includes('/pagamenti') || currentPath.includes('pagamento')) {
        currentTag = 'pagamenti';
      } else if (currentPath.includes('/iniziative') || currentPath.includes('iniziative')) {
        currentTag = 'iniziative';
      } else if (currentPath.includes('/comunicati') || currentPath.includes('comunicazioni')) {
        currentTag = 'comunicati';
      } else if (currentPath.includes('/scadenzario') || currentPath.includes('scadenzario')) {
        currentTag = 'scadenzario';
      } else if (currentPath.includes('/rassegna') || currentPath.includes('rassegna')) {
        currentTag = 'rassegna';
      } else if (currentPath.includes('/tributi') || currentPath.includes('tributi')) {
        currentTag = 'tributi';
      } else {
        // Fallback: prova a determinare dalla prop servizio
        const serviceLower = (servizio || '').toLowerCase();
        if (serviceLower.includes('personalizz')) {
          currentTag = 'personalizzato';
        } else if (serviceLower.includes('pagament')) {
          currentTag = 'pagamenti';
        } else if (serviceLower.includes('iniziativ')) {
          currentTag = 'iniziative';
        } else if (serviceLower.includes('comunica')) {
          currentTag = 'comunicati';
        } else if (serviceLower.includes('scadenzar')) {
          currentTag = 'scadenzario';
        } else if (serviceLower.includes('rassegn')) {
          currentTag = 'rassegna';
        } else if (serviceLower.includes('tribut')) {
          currentTag = 'tributi';
        } else {
          currentTag = ''; // Carica tutti se non specificato
        }
      }

      console.log('🏷️ Caricamento template per tag:', currentTag || 'tutti', 'dalla route:', currentPath);

      // 🔧 CARICA TEMPLATE FILTRATI PER TAG - ENDPOINT REALE
      const url = currentTag ? `/api/Mail/templates/by-tag/${currentTag}` : '/api/Mail/templates';
      const response = await apiFetch(url);
      
      if (response.ok) {
        const result = await response.json();
        
        // 🔧 GESTISCI LA STRUTTURA RESPONSE REALE
        if (result.success && result.data) {
          // 🔧 CONTROLLO CRITICO: assicurati che sia sempre un array
          const templatesData = Array.isArray(result.data) ? result.data : [];
          
          // 🔧 DECODIFICA I CARATTERI UNICODE ESCAPED
          const decodedTemplates = templatesData.map(template => ({
            ...template,
            // Decodifica il contenuto che ha caratteri escape Unicode
            content: template.content ? 
              template.content
                .replace(/\\u0022/g, '"')
                .replace(/\\u0026/g, '&')
                .replace(/\\u003C/g, '<')
                .replace(/\\u003E/g, '>')
                .replace(/\\u0027/g, "'")
                .replace(/\\n/g, '\n')
                .replace(/\\r/g, '\r')
                .replace(/\\t/g, '\t')
              : '',
            // Decodifica anche subject se necessario
            subject: template.subject ?
              template.subject
                .replace(/\\u0022/g, '"')
                .replace(/\\u0026/g, '&')
                .replace(/\\u003C/g, '<')
                .replace(/\\u003E/g, '>')
                .replace(/\\u0027/g, "'")
              : '',
            // Decodifica description
            description: template.description ?
              template.description
                .replace(/\\u0022/g, '"')
                .replace(/\\u0026/g, '&')
                .replace(/\\u003C/g, '<')
                .replace(/\\u003E/g, '>')
                .replace(/\\u0027/g, "'")
              : ''
          }));
          
          console.log('📄 Template caricati e decodificati:', decodedTemplates.length, 'per sezione:', currentTag || 'tutte');
          console.log('🔍 Template trovati:', decodedTemplates.map(t => ({ id: t.id, name: t.name, tags: t.tags })));
          
          setTemplates(decodedTemplates);
          
          // 🔧 MIGRAZIONE SOLO SE NON CI SONO TEMPLATE E NON È GIÀ STATA FATTA
          if (decodedTemplates.length === 0) {
            await migrateFromLocalStorage();
          }
        } else {
          console.error('❌ Risposta API non valida:', result);
          // 🔧 FALLBACK SICURO: array vuoto
          setTemplates([]);
        }
      } else {
        console.error('❌ Errore caricamento template:', response.status);
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (error) {
      console.error('❌ Errore caricamento template:', error);
      // 🔧 FALLBACK A LOCALSTORAGE IN CASO DI ERRORE BACKEND
      try {
        const localTemplates = JSON.parse(localStorage.getItem('email_templates') || '[]');
        const templatesArray = Array.isArray(localTemplates) ? localTemplates : [];
        console.log('📄 Fallback: caricati', templatesArray.length, 'template da localStorage');
        setTemplates(templatesArray);
      } catch (localError) {
        console.error('❌ Errore anche nel fallback localStorage:', localError);
        setTemplates([]);
      }
    }
  };

  // 🔧 FUNZIONE MIGRAZIONE DA LOCALSTORAGE (UNA TANTUM)
  const migrateFromLocalStorage = async () => {
    try {
      const localTemplates = JSON.parse(localStorage.getItem('email_templates') || '[]');
      
      const migrationDone = localStorage.getItem('templates_migrated') === 'true';
      
      if (localTemplates.length > 0 && !migrationDone) {
        console.log('🔄 Migrazione', localTemplates.length, 'template da localStorage al backend...');
        
        localStorage.setItem('templates_migrated', 'true');
        
        let migratedCount = 0;
        
        for (const template of localTemplates) {
          try {
            // 🔧 DETERMINA IL TAG CORRETTO DALLA ROUTE CORRENTE - TUTTE LE 7 SEZIONI
            const currentPath = window.location.pathname;
            let migratedTag = 'generale'; // default
            
            if (currentPath.includes('/personalizzato')) migratedTag = 'personalizzato';
            else if (currentPath.includes('/pagamenti')) migratedTag = 'pagamenti';
            else if (currentPath.includes('/iniziative')) migratedTag = 'iniziative';
            else if (currentPath.includes('/comunicati')) migratedTag = 'comunicati';
            else if (currentPath.includes('/scadenzario')) migratedTag = 'scadenzario';
            else if (currentPath.includes('/rassegna')) migratedTag = 'rassegna';
            else if (currentPath.includes('/tributi')) migratedTag = 'tributi';
            
            // ...resto del codice existing...
          } catch (templateError) {
            console.error('❌ Errore migrazione singolo template:', templateError);
          }
        }
        // ...resto del codice existing...
      }
    } catch (error) {
      console.error('❌ Errore migrazione:', error);
      localStorage.setItem('templates_migrated', 'true');
    }
  };

  // 🔧 SALVA TEMPLATE SUL BACKEND INVECE DI LOCALSTORAGE
  const saveTemplate = async (templateData) => {
    try {
      console.log('💾 Salvataggio template sul backend...');
      
      // 🔧 PREPARA I DATI SECONDO LA STRUTTURA RICHIESTA
      const templatePayload = {
        id: "", // 🔥 ID VUOTO COME RICHIESTO DAL BACKEND
        name: templateData.name || '',
        description: templateData.description || '',
        subject: templateData.subject || '',
        content: templateData.content || '',
        createdBy: templateData.createdBy || 'user',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        isActive: templateData.isActive !== undefined ? templateData.isActive : true,
        isShared: templateData.isShared !== undefined ? templateData.isShared : true,
        category: templateData.category || 'Generale',
        tags: templateData.tags || 'generale'
      };

      console.log('📤 Payload template:', templatePayload);

      const response = await apiFetch('/api/Mail/templates', {
        method: 'POST',
        body: JSON.stringify(templatePayload)
      });
      
      if (response.ok) {
        const result = await response.json();
        
        if (result.success) {
          console.log('✅ Template salvato sul backend:', result.message);
          console.log('📄 Template creato con ID:', result.data?.id);
          
          // 🔧 RICARICA I TEMPLATE SOLO SE NON È UNA MIGRAZIONE
          if (templateData.createdBy !== 'migrated') {
            await loadTemplates();
            alert('Template salvato con successo!');
          }
          
          return result.data; // Restituisce il template creato con il nuovo ID
        } else {
          throw new Error(result.message || 'Errore del server');
        }
      } else {
        const errorText = await response.text();
        throw new Error(`Errore HTTP ${response.status}: ${errorText}`);
      }
    } catch (error) {
      console.error('❌ Errore salvataggio template:', error);
      
      // 🔧 MOSTRA ALERT SOLO SE NON È UNA MIGRAZIONE
      if (templateData.createdBy !== 'migrated') {
        alert(`Errore durante il salvataggio del template: ${error.message}`);
      }
      
      // 🔧 FALLBACK A LOCALSTORAGE SE BACKEND FALLISCE (solo per template utente)
      if (templateData.createdBy !== 'migrated') {
        try {
          const existingTemplates = JSON.parse(localStorage.getItem('email_templates') || '[]');
          const localTemplate = {
            ...templateData,
            id: templateData.id || `template_${Date.now()}`,
            created: new Date().toISOString()
          };
          
          const updatedTemplates = [...existingTemplates, localTemplate];
          localStorage.setItem('email_templates', JSON.stringify(updatedTemplates));
          setTemplates(updatedTemplates);
          
          console.log('💾 Fallback: template salvato in localStorage');
          alert('Template salvato localmente (fallback)');
        } catch (localError) {
          console.error('❌ Errore fallback localStorage:', localError);
        }
      }
    }
  };

  // 🔧 ELIMINA TEMPLATE DAL BACKEND
  const deleteTemplate = async (templateId) => {
    try {
      console.log('🗑️ Eliminazione template dal backend:', templateId);
      
      const response = await apiFetch(`/api/Mail/templates/${templateId}`, {
        method: 'DELETE'
      });
      
      if (response.ok) {
        const result = await response.json();
        
        if (result.success) {
          console.log('✅ Template eliminato dal backend:', result.message);
          await loadTemplates(); // Ricarica la lista
          alert('Template eliminato con successo!');
        } else {
          throw new Error(result.message || 'Errore del server');
        }
      } else {
        const errorText = await response.text();
        throw new Error(`Errore HTTP ${response.status}: ${errorText}`);
      }
    } catch (error) {
      console.error('❌ Errore eliminazione template:', error);
      alert(`Errore durante l'eliminazione del template: ${error.message}`);
      
      // 🔧 FALLBACK A LOCALSTORAGE SE BACKEND FALLISCE
      try {
        const existingTemplates = JSON.parse(localStorage.getItem('email_templates') || '[]');
        const updatedTemplates = existingTemplates.filter(t => t.id !== templateId);
        localStorage.setItem('email_templates', JSON.stringify(updatedTemplates));
        setTemplates(updatedTemplates);
        
        console.log('💾 Fallback: template eliminato da localStorage');
        alert('Template eliminato localmente (fallback)');
      } catch (localError) {
        console.error('❌ Errore fallback localStorage:', localError);
      }
    }
  };

  // Carica i template al mount
  // useEffect(() => {
  //   const loadedTemplates = loadTemplates();
  //   setTemplates(loadedTemplates);
  // }, []);

  useEffect(() => {
    Promise.all([
      loadTemplates(),
      loadProviders()
    ]).then(() => {
      console.log('✅ Inizializzazione completata');
    }).catch(error => {
      console.error('❌ Errore inizializzazione:', error);
    });
  }, []);

  // const reloadTemplates = () => {
  //   console.log('🔄 Ricarico manuale template...');
  //   loadTemplates();
  // };
  // Carica provider SMTP
  // useEffect(() => {
  //   loadTemplates();
    
  //   // 🔧 LISTENER PER CAMBIAMENTI ROUTE (se l'app usa routing dinamico)
  //   const handleRouteChange = () => {
  //     console.log('📍 Route cambiata, ricarico template...');
  //     setTimeout(() => loadTemplates(), 100); // Piccolo delay per evitare race condition
  //   };
    
  //   // Se usi React Router, aggiungi listener
  //   window.addEventListener('popstate', handleRouteChange);
  
  //   return () => {
  //     window.removeEventListener('popstate', handleRouteChange);
  //   };
  // }, [servizio]);

  // AUTO-RILEVAMENTO ALLEGATI TESSERA
  useEffect(() => {
    const hasFileUrl = selectedRows && selectedRows.some(row => 
      row.fileUrl && row.fileUrl.startsWith('tessera://')
    );
    
    if (hasFileUrl) {
      setHasAttachments(true);
      console.log('🎫 Allegati tessera rilevati automaticamente');
    }
  }, [selectedRows]);

  // Funzioni per la gestione template
  const handleLoadTemplate = (templateId) => {
    const template = templates.find(t => t.id === templateId);
    if (template) {
      setSubject(template.subject || '');
      setContent(template.content || '');
      
      // Imposta nell'editor se presente
      if (editorDomRef.current && editorDomRef.current.editor) {
        editorDomRef.current.editor.setContent(template.content || '');
      }
      
      console.log('Template caricato:', template.name);
    }
  };

  const handleSaveTemplate = async () => {
    if (!templateName.trim()) {
      alert('Inserisci un nome per il template');
      return;
    }

    // 🔧 DETERMINA TAG AUTOMATICAMENTE SE NON SELEZIONATO - TUTTE LE 7 SEZIONI
    let finalTag = templateTag;
    if (!finalTag) {
      const currentPath = window.location.pathname;
      if (currentPath.includes('/personalizzato')) finalTag = 'personalizzato';
      else if (currentPath.includes('/pagamenti')) finalTag = 'pagamenti';
      else if (currentPath.includes('/iniziative')) finalTag = 'iniziative';
      else if (currentPath.includes('/comunicati')) finalTag = 'comunicati';
      else if (currentPath.includes('/scadenzario')) finalTag = 'scadenzario';
      else if (currentPath.includes('/rassegna')) finalTag = 'rassegna';
      else if (currentPath.includes('/tributi')) finalTag = 'tributi';
      else finalTag = 'generale';
    }

    const newTemplate = {
      name: templateName.trim(),
      description: templateDescription.trim(),
      subject: subject,
      content: content,
      category: templateCategory.trim() || 'Generale',
      tags: finalTag,
      createdBy: 'user', // Sostituisci con l'utente corrente se disponibile
      isActive: true,
      isShared: true
    };

    console.log('💾 Salvataggio template:', newTemplate.name);
    
    // Salva il template
    const savedTemplate = await saveTemplate(newTemplate);

    // Reset form
    setTemplateName('');
    setTemplateDescription('');
    setTemplateCategory('');
    setTemplateTag('');
    setShowSaveTemplate(false);

    // Seleziona il template appena creato se il salvataggio è riuscito
    if (savedTemplate && savedTemplate.id) {
      setSelectedTemplate(savedTemplate.id);
    }
    
    // 🔧 RICARICA TEMPLATE DOPO SALVATAGGIO
    setTimeout(() => loadTemplates(), 500);
  };

  const handleDeleteTemplate = async (templateId) => {
    if (window.confirm('Sei sicuro di voler eliminare questo template?')) {
      await deleteTemplate(templateId);

      if (selectedTemplate === templateId) {
        setSelectedTemplate('');
      }
    }
  };

  const handleUpdateTemplate = async (templateId) => {
    if (!subject.trim() || !content.trim()) {
      alert('Oggetto e contenuto non possono essere vuoti.');
      return;
    }
    const tmpl = templates.find(t => t.id === templateId);
    if (!window.confirm(`Aggiornare il template "${tmpl?.name || templateId}" con il contenuto corrente?`)) return;

    try {
      const response = await apiFetch(`/api/Mail/templates/${templateId}`, {
        method: 'PUT',
        body: JSON.stringify({ subject, content })
      });
      if (response.ok) {
        await loadTemplates();
        alert('Template aggiornato!');
      } else {
        alert('Errore durante l\'aggiornamento del template.');
      }
    } catch {
      alert('Errore durante l\'aggiornamento del template.');
    }
  };

  // Gestione allegati
  const handleAttachments = (e) => {
    const files = e.target.files;
    if (files) {
      // Verifica dimensioni
      const maxFileSize = 10 * 1024 * 1024; // 10MB
      const maxTotalSize = 25 * 1024 * 1024; // 25MB
      
      let totalSize = 0;
      const validFiles = [];
      
      for (let file of files) {
        if (file.size > maxFileSize) {
          alert(`Il file "${file.name}" supera la dimensione massima di 10MB`);
          continue;
        }
        totalSize += file.size;
        validFiles.push(file);
      }
      
      if (totalSize > maxTotalSize) {
        alert('La dimensione totale degli allegati supera i 25MB');
        return;
      }
      
      setAttachments(validFiles);
      console.log(`Allegati selezionati: ${validFiles.length} file, ${(totalSize / 1024 / 1024).toFixed(2)} MB`);
    }
  };

  // Inserimento placeholders
  const insertPlaceholder = (placeholder) => {
    if (editorDomRef.current && editorDomRef.current.editor) {
      editorDomRef.current.editor.execCommand('mceInsertContent', false, placeholder);
    } else {
      setContent(prev => prev + placeholder);
    }
  };

  // Validazione form
  const validateForm = () => {
    if (!subject.trim()) {
      alert('Inserisci l\'oggetto dell\'email');
      return false;
    }
    
    if (!content.trim()) {
      alert('Inserisci il contenuto dell\'email');
      return false;
    }
    
    if (testMode && !testEmails.trim()) {
      alert('Inserisci almeno un indirizzo email per il test');
      return false;
    }
    
    if (sendCopy && !copyEmails.trim()) {
      alert('Inserisci almeno un indirizzo email per la copia');
      return false;
    }
    
    return true;
  };

  // FUNZIONE PRINCIPALE DI INVIO
  const handleSendEmailInBatches = async () => {
    if (!validateForm()) return;

    // Preparazione dati base
    const idProviderString = provider ? provider.toString() : '0';
    const emailTestString = testMode && testEmails ? 
      testEmails.split(',').map(e => e.trim()).filter(Boolean).join(',') : '';
    const emailCcString = sendCopy && copyEmails ? 
      copyEmails.split(',').map(e => e.trim()).filter(Boolean).join(',') : '';

    // Configurazione batch
    const maxBatchSize = 5000;
    const totalBatches = Math.ceil(selectedRows.length / maxBatchSize);

    // Controllo se ci sono file tessera
    const hasTesseraFiles = selectedRows && selectedRows.some(row => 
      row.fileUrl && row.fileUrl.startsWith('tessera://')
    );

    // Controllo se ci sono file utente
    const hasUserFiles = hasAttachments && attachments && attachments.length > 0;

    setSending(true);
    setShouldContinue(true);
    setShowSendProgress(true);
    setSendingProgress('Preparazione invio...');
    setSendPartialError(null);

    let allResults = [];
    let successCount = 0;
    let errorCount = 0;
    let batchErrorMessage = null;

    try {
      for (let i = 0; i < totalBatches; i++) {
        // Controllo annullamento
        if (!shouldContinue) {
          console.log('❌ Invio annullato dall\'utente');
          setSendingProgress('Invio annullato');
          break;
        }

        const batchNumber = i + 1;
        const start = i * maxBatchSize;
        const end = Math.min(start + maxBatchSize, selectedRows.length);
        const batch = selectedRows.slice(start, end);

        setSendingProgress(`Invio batch ${batchNumber}/${totalBatches} (${batch.length} email)...`);

        // 🔧 FUNZIONE PER PROCESSARE PLACEHOLDER GLOBALI - VERSIONE URL ASSOLUTI
        const processGlobalPlaceholders = () => {
          // Data odierna
          const today = new Date();
          const giorni = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
          const mesi = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 
                      'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
          const dataOdierna = `${giorni[today.getDay()]}, ${today.getDate()} ${mesi[today.getMonth()]} ${today.getFullYear()}`;

          // 🔧 CORREZIONE: URL Assoluti per le immagini
          const globalPlaceholders = {
            '{DATA_ODIERNA}': dataOdierna,
            '{{DATA_ODIERNA}}': dataOdierna,
            '{IMMAGINE_INTESTAZIONE}': '<img src="https://www.anutel.it/data/impostazioni_grafiche_email/intestazione.jpg" alt="Intestazione ANUTEL" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />',
            '{{IMMAGINE_INTESTAZIONE}}': '<img src="https://www.anutel.it/data/impostazioni_grafiche_email/intestazione.jpg" alt="Intestazione ANUTEL" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />',
            '{IMMAGINE_FONDO}': '<img src="https://www.anutel.it/data/impostazioni_grafiche_email/piepagina.jpg" alt="Piè di pagina ANUTEL" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />',
            '{{IMMAGINE_FONDO}}': '<img src="https://www.anutel.it/data/impostazioni_grafiche_email/piepagina.jpg" alt="Piè di pagina ANUTEL" style="max-width: 100%; height: auto; display: block; margin: 0 auto;" />',
            '{FIRMA_ANUTEL}': '<img src="https://www.anutel.it/data/impostazioni_grafiche_email/firma.jpg" alt="Firma ANUTEL" style="width: 150px;" />',
            '{{FIRMA_ANUTEL}}': '<img src="https://www.anutel.it/data/impostazioni_grafiche_email/firma.jpg" alt="Firma ANUTEL" style="width: 150px;" />'
          };

          console.log('🖼️ Placeholder globali preparati con URL assoluti:', Object.keys(globalPlaceholders));
          return globalPlaceholders;
        };

        // 🔄 PREPARAZIONE NUOVO JSON MAIL
        const mailJsonArray = batch.map((row, index) => {
          // 🔧 GESTIONE CONTENUTO CON PLACEHOLDER SOSTITUITI - CORRETTA
          let processedContent = content;
          
          // 🔄 PRIMA: Sostituisci i PLACEHOLDER GLOBALI (con URL assoluti)
          const globalPlaceholders = processGlobalPlaceholders();
          
          // Sostituisci i placeholder globali
          Object.keys(globalPlaceholders).forEach(placeholder => {
            const regex = new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'gi');
            const beforeReplace = processedContent;
            processedContent = processedContent.replace(regex, globalPlaceholders[placeholder]);
            
            if (beforeReplace !== processedContent) {
              console.log(`✅ Sostituito placeholder globale ${placeholder} per riga ${index}`);
            }
          });

          // 🔄 SECONDO: Sostituisci i placeholder specifici della riga
          if (placeholders && placeholders.length > 0) {
            placeholders.forEach(placeholder => {
              // 🔧 CORREZIONE BUG: Controlla SOLO le varianti effettive del placeholder globale
              const placeholderNormalized = placeholder.replace(/[{}]/g, '').toUpperCase();
              const isGlobalPlaceholder = ['DATA_ODIERNA', 'IMMAGINE_INTESTAZIONE', 'IMMAGINE_FONDO', 'FIRMA_ANUTEL'].includes(placeholderNormalized);

              if (isGlobalPlaceholder) {
                return; // Skip - già processato nei placeholder globali
              }

              // 🔧 FIX INIZIATIVE: Gestione placeholder con prefissi INIZIATIVA_ e PRENOTAZIONE_
              let fieldValue = '';
              let fieldName = placeholder.replace(/[{}]/g, '').toLowerCase().trim();

              // Controlla se il placeholder ha un prefisso speciale
              if (placeholderNormalized.startsWith('INIZIATIVA_')) {
                // 🔧 Placeholder dell'iniziativa: cerca in iniziativaData
                const actualFieldName = placeholderNormalized.replace('INIZIATIVA_', '').toLowerCase();

                if (iniziativaData) {
                  // Cerca il campo nell'iniziativaData (case-insensitive)
                  Object.keys(iniziativaData).forEach(key => {
                    if (key.toLowerCase() === actualFieldName) {
                      fieldValue = iniziativaData[key] || '';
                    }
                  });
                }

                console.log(`🎯 Placeholder INIZIATIVA: ${placeholder} -> fieldName: ${actualFieldName} -> value: "${fieldValue}"`);
              } else if (placeholderNormalized.startsWith('PRENOTAZIONE_')) {
                // 🔧 Placeholder del partecipante: rimuovi prefisso e cerca in row
                const actualFieldName = placeholderNormalized.replace('PRENOTAZIONE_', '').toLowerCase();
                fieldName = actualFieldName; // Usa il nome senza prefisso per cercare

                console.log(`🎯 Placeholder PRENOTAZIONE: ${placeholder} -> fieldName: ${fieldName}`);
                // fieldValue verrà risolto dalla logica sottostante
              } else {
                // Placeholder standard senza prefisso
                console.log(`🔧 Placeholder standard: ${placeholder} -> fieldName: ${fieldName}`);
              }
              
              // 🔧 CORREZIONE COMPLETA: Mappature specifiche per SOLLECITI e altri servizi
              const fieldMappings = {
                // Campi standard
                'nome': row.nome || row.denominazione || row.ragioneSociale || row.cognomeNome || row.Name || '',
                'cognome': row.cognome || row.Cognome || row.surname || '',
                'denominazione': row.denominazione || row.ragioneSociale || row.nome || row.cognomeNome || row.Name || '',
                'ragionesociale': row.ragioneSociale || row.denominazione || row.nome || row.cognomeNome || row.Name || '',
                'ragione_sociale': row.ragioneSociale || row.denominazione || row.nome || row.cognomeNome || row.Name || '',
                'email': row.email || row.mail || row.emailOrd?.[0] || row.Email || row.EmailOrdinaria || '',
                'mail': row.mail || row.email || row.emailOrd?.[0] || row.Email || row.EmailOrdinaria || '',
                'emailordinaria': row.emailOrd?.[0] || row.email || row.mail || row.EmailOrdinaria || row.Email || '',
                'email_ordinaria': row.emailOrd?.[0] || row.email || row.mail || row.EmailOrdinaria || row.Email || '',
                'pec': row.emailPec?.[0] || row.EmailPec || row.pec || '',
                'emailpec': row.emailPec?.[0] || row.EmailPec || row.pec || '',
                'email_pec': row.emailPec?.[0] || row.EmailPec || row.pec || '',
                'indirizzo': row.indirizzo || row.via || row.address || row.Indirizzo || '',
                'via': row.via || row.indirizzo || row.address || row.Via || '',
                'comune': row.comune || row.city || row.citta || row.Comune || '',
                'citta': row.citta || row.comune || row.city || row.Citta || '',
                'città': row.citta || row.comune || row.city || row.Citta || '',
                'provincia': row.provincia || row.prov || row.siglaProv || row.Provincia || '',
                'prov': row.prov || row.provincia || row.siglaProv || row.Provincia || '',
                'siglaprov': row.siglaProv || row.prov || row.provincia || row.Provincia || '',
                'regione': row.regione || row.Regione || '',
                'cap': row.cap || row.zipCode || row.Cap || row.ZIP || '',
                'telefono': row.telefono || row.phone || row.tel || row.Telefono || '',
                'tel': row.tel || row.telefono || row.phone || row.Tel || '',
                'phone': row.phone || row.telefono || row.tel || row.Phone || '',
                'ente': row.ente || row.denominazione || row.Ente || '',
                'codicefiscale': row.codiceFiscale || row.cf || row.CodiceFiscale || row.CF || '',
                'codice_fiscale': row.codiceFiscale || row.cf || row.CodiceFiscale || row.CF || '',
                'cf': row.cf || row.codiceFiscale || row.CF || row.CodiceFiscale || '',
                'partitaiva': row.partitaIva || row.piva || row.pi || row.PartitaIva || row.PI || '',
                'partita_iva': row.partitaIva || row.piva || row.pi || row.PartitaIva || row.PI || '',
                'piva': row.piva || row.partitaIva || row.pi || row.Piva || row.PI || '',
                'pi': row.pi || row.partitaIva || row.piva || row.PI || row.PartitaIva || '',
                
                // 🔧 CAMPI SPECIFICI PER PAGAMENTI - CORREZIONE TIPOENTE
                'tipoente': row.tipoEnte || '', // 🔧 CORRETTO: era row.ente, ora row.tipoEnte
                'tipo_ente': row.tipoEnte || '',
                'pagamento': row.pagamento || '',
                'data': row.data || '',
                'fileurl': row.fileUrl || '',
                'file_url': row.fileUrl || '',
                
                // 🔧 CAMPI SPECIFICI PER SOLLECITI
                'codicetessera': row.codiceTessera || '',
                'codice_tessera': row.codiceTessera || '',
                'datainizio': row.dataInizio || '',
                'data_inizio': row.dataInizio || '',
                'tipo': row.tipo || '',
                'recapito': row.recapito || '',
                'anni': row.anni || '',
                'debiti': row.debitiFormatted || row.debiti || '',
                'totale': row.totaleFormatted || row.totale || '',
                'polizza': row.polizza || 'NO',
                 
                // 🔧 CAMPI SPECIFICI PER POLIZZE
                'cognome_nome': row.cognomeNome || row.nome || '',
                'cognomenome': row.cognomeNome || row.nome || '',
                'data_fine': row.dataFine || '',
                'datafine': row.dataFine || '',
                'destinatari': row.destinatari || row.email || '',
                'importo': row.importo || '',
                'note': row.note || '',
                'tipo_adesione': row.tipoAdesione || '',
                'tipoadesione': row.tipoAdesione || '',
                'adesione': row.tipoAdesione || ''
              };

              // 🔧 FIX: Solo per placeholder non INIZIATIVA_ (che hanno già fieldValue impostato)
              if (!placeholderNormalized.startsWith('INIZIATIVA_')) {
                // Prova prima con le mappature specifiche
                if (!fieldValue) {
                  fieldValue = fieldMappings[fieldName];
                }

                // Se non trovato nelle mappature, cerca direttamente nei campi della riga (case-insensitive)
                if (!fieldValue) {
                Object.keys(row).forEach(rowKey => {
                  const rowKeyLower = rowKey.toLowerCase();
                  if (rowKeyLower === fieldName || 
                      rowKeyLower.includes(fieldName) ||
                      fieldName.includes(rowKeyLower)) {
                    fieldValue = row[rowKey] || '';
                  }
                });
                }
              }

              // 🔍 DEBUG DETTAGLIATO per placeholder specifici
              if (fieldName === 'codicetessera' || fieldName === 'codice_tessera' || fieldName === 'datainizio' || fieldName === 'data_inizio' || fieldName === 'cognome_nome' || fieldName === 'data_fine') {
                console.log(`🔍 DEBUG PLACEHOLDER "${placeholder}":`, {
                  fieldName: fieldName,
                  foundValue: fieldValue,
                  codiceTessera: row.codiceTessera,
                  dataInizio: row.dataInizio,
                  dataFine: row.dataFine,
                  cognomeNome: row.cognomeNome,
                  fromMapping: !!fieldMappings[fieldName],
                  allRowKeys: Object.keys(row),
                  rowKeys: Object.keys(row).filter(k => k.toLowerCase().includes('tessera') || k.toLowerCase().includes('inizio') || k.toLowerCase().includes('cognome') || k.toLowerCase().includes('fine'))
                });
              }
              
              // 🔧 FORMATTAZIONE DATE: Se il fieldValue è una data, formattala senza orario
              if (fieldValue && typeof fieldValue === 'string') {
                // Regex per date in formato MM/DD/YYYY HH:MM:SS o DD/MM/YYYY HH:MM:SS
                const dateTimeRegex = /^(\d{1,2}\/\d{1,2}\/\d{4})\s+\d{2}:\d{2}:\d{2}$/;
                const match = fieldValue.match(dateTimeRegex);

                if (match) {
                  // Estrae solo la parte della data (senza orario)
                  const datePart = match[1]; // Es: "01/21/2026"

                  // Converti da MM/DD/YYYY a DD/MM/YYYY se necessario
                  const parts = datePart.split('/');
                  if (parts.length === 3) {
                    const [first, second, year] = parts;
                    // Se il primo numero è > 12, è già in formato DD/MM/YYYY
                    // Altrimenti è in formato MM/DD/YYYY e va convertito
                    if (parseInt(first) <= 12 && parseInt(second) > 12) {
                      // È in formato MM/DD/YYYY, converti in DD/MM/YYYY
                      fieldValue = `${second}/${first}/${year}`;
                    } else {
                      // È già in formato corretto, usa solo la data
                      fieldValue = datePart;
                    }
                  }

                  console.log(`📅 Formattata data: "${match[0]}" -> "${fieldValue}"`);
                }
              }

              // 🔧 CORREZIONE IMPORTANTE: Sostituisci il placeholder nel contenuto
              // Usa escape per caratteri speciali e flag globale
              const placeholderEscaped = placeholder.replace(/[{}]/g, '\\$&');
              const regex = new RegExp(placeholderEscaped, 'gi');

              // Controlla se il placeholder esiste nel contenuto
              const beforeReplace = processedContent;
              processedContent = processedContent.replace(regex, fieldValue || '');
              
              // Verifica se la sostituzione è avvenuta
              if (beforeReplace !== processedContent) {
                console.log(`✅ Sostituito ${placeholder} -> "${fieldValue || '[VUOTO]'}" per riga ${index}`);
              } else {
                console.log(`⚠️ Placeholder ${placeholder} NON TROVATO nel contenuto per riga ${index}`);
              }
            });
          }
          
          // 🔍 DEBUG: Log contenuto processato
          const placeholdersRemaining = (processedContent.match(/\{\{?[a-zA-Z_][a-zA-Z0-9_]*\}?\}/g) || []);
          console.log(`📝 CONTENUTO PROCESSATO per riga ${index}:`, {
            originalLength: content.length,
            processedLength: processedContent.length,
            placeholdersInOriginal: (content.match(/\{\{?[^}]+\}?\}/g) || []).length,
            placeholdersRemaining: placeholdersRemaining.length,
            remainingPlaceholders: placeholdersRemaining, // 🔧 AGGIUNTO: mostra quali placeholder non sono stati sostituiti
            hasChanges: content !== processedContent,
            hasAbsoluteUrls: processedContent.includes('https://www.anutel.it'),
            rowId: row.id || `index_${index}`,
            rowServiceData: {
              codiceTessera: row.codiceTessera,
              cognomeNome: row.cognomeNome,
              dataInizio: row.dataInizio,
              dataFine: row.dataFine
            }
          });
          
          // Determina TipoAllegato per questo elemento
          // 🔧 FIX: Solo se hasAttachments è true, altrimenti nessun allegato
          let tipoAllegato = '';
          if (hasAttachments) {
            if (row.fileUrl && row.fileUrl.startsWith('tessera://')) {
              tipoAllegato = row.fileUrl; // "tessera://nome_file"
            } else if (row.TipoAllegato === 'polizza') {
              tipoAllegato = 'polizza';
            } else if (hasUserFiles) {
              tipoAllegato = 'file';
            }
          }

          // Gestione EmailOrd
          const emailOrdArray = [];
          
          if (row.email) {
            if (typeof row.email === 'string' && row.email.trim()) {
              emailOrdArray.push(row.email.trim());
            } else if (Array.isArray(row.email)) {
              row.email.forEach(email => {
                if (typeof email === 'string' && email.trim()) {
                  emailOrdArray.push(email.trim());
                }
              });
            }
          }

          if (row.emailOrd) {
            if (typeof row.emailOrd === 'string' && row.emailOrd.trim()) {
              const emailOrdTrimmed = row.emailOrd.trim();
              if (!emailOrdArray.includes(emailOrdTrimmed)) {
                emailOrdArray.push(emailOrdTrimmed);
              }
            } else if (Array.isArray(row.emailOrd)) {
              row.emailOrd.forEach(email => {
                if (typeof email === 'string' && email.trim()) {
                  const emailTrimmed = email.trim();
                  if (!emailOrdArray.includes(emailTrimmed)) {
                    emailOrdArray.push(emailTrimmed);
                  }
                }
              });
            }
          }

          // Gestione EmailPec
          const emailPecArray = [];
          
          if (row.emailPec) {
            if (typeof row.emailPec === 'string' && row.emailPec.trim()) {
              emailPecArray.push(row.emailPec.trim());
            } else if (Array.isArray(row.emailPec)) {
              row.emailPec.forEach(email => {
                if (typeof email === 'string' && email.trim()) {
                  emailPecArray.push(email.trim());
                }
              });
            }
          }

          return {
            id: index,
            contenuto: processedContent, // ✅ Contenuto con placeholder sostituiti e URL assoluti
            TipoAllegato: tipoAllegato,
            EmailOrd: emailOrdArray,
            EmailPec: emailPecArray
          };
        });

        // 🔄 CREAZIONE FORMDATA
        const batchFormData = new FormData();
        batchFormData.append('servizio', servizio);
        batchFormData.append('oggetto', subject);
        batchFormData.append('idProvider', idProviderString);
        batchFormData.append('priorita', 'normal');
        batchFormData.append('emailTest', emailTestString);
        batchFormData.append('emailCc', emailCcString);
        batchFormData.append('mail', JSON.stringify(mailJsonArray));

        // 🎫 GESTIONE ALLEGATI TESSERA
        // 🔧 FIX: Solo se hasAttachments è true
        if (hasAttachments) {
          const tesseraFilesInBatch = batch.filter(item => item.fileUrl && item.fileUrl.startsWith('tessera://'));
          if (tesseraFilesInBatch.length > 0) {
            console.log('🎫 Allegati tessera nel batch:', tesseraFilesInBatch.map(f => f.fileUrl));
            tesseraFilesInBatch.forEach(item => {
              const tesseraFile = new File([''], item.fileUrl, { type: 'application/pdf' });
              batchFormData.append('allegati', tesseraFile);
            });
          }
        }

        // 📎 ALLEGATI UTENTE
        if (!hasTesseraFiles && hasUserFiles) {
          console.log('📎 Allegati utente aggiunti:', Array.from(attachments).map(f => f.name));
          Array.from(attachments).forEach(file => {
            batchFormData.append('allegati', file);
          });
        }

        // Invio richiesta
        try {
          const batchTimeout = 120000; // 2 min — attende la transazione DB di accodamento

          setSendingProgress(`Accodamento batch ${batchNumber}/${totalBatches} (${batch.length} elementi)...`);

          const response = await apiFetch('/api/Mail/sendblock', {
            method: 'POST',
            body: batchFormData,
            timeout: batchTimeout
          });

          if (response.ok) {
            const result = await response.json();

            // Nuovo formato asincrono: backend risponde immediatamente con jobId
            if (result.jobId) {
              // Mostra subito il modale — l'invio prosegue in background
              allResults.push({
                accodato:   true,
                jobId:      result.jobId,
                servizio:   result.servizio,
                oggetto:    result.oggetto,
                dataInvio:  new Date().toLocaleString(),
                totalEmails: result.totalEmails || 0,
                inviRiusciti: 0,
                inviFalliti:  0,
                emails: []
              });

              console.log(`✅ Job ${result.jobId.substring(0,8)} accodato: ${result.totalEmails} email in background`);

            } else {
              // Formato sincrono legacy
              let summaryData = null;
              let batchResultsCount = 0;

              if (result.summary && result.responses) {
                summaryData = result.summary;
                allResults.push(...result.responses);
                batchResultsCount = result.responses.length;
              } else if (Array.isArray(result)) {
                allResults.push(...result);
                batchResultsCount = result.length;
              } else {
                allResults.push(result);
                batchResultsCount = 1;
              }

              let successFromResult, errorsFromResult;
              if (summaryData) {
                successFromResult = summaryData.totalSent  || 0;
                errorsFromResult  = summaryData.totalFailed || 0;
              } else {
                const batchStartIndex = allResults.length - batchResultsCount;
                const batchResults = allResults.slice(batchStartIndex);
                successFromResult = batchResults.reduce((sum, r) => sum + (r.inviRiusciti || 0), 0);
                errorsFromResult  = batchResults.reduce((sum, r) => sum + (r.inviFalliti  || 0), 0);
              }

              successCount += successFromResult;
              errorCount   += errorsFromResult;

              console.log(`✅ Batch ${batchNumber} completato: ${successFromResult} successi, ${errorsFromResult} errori`);
            }

          } else {
            const errorText = await response.text();
            console.error(`❌ Errore batch ${batchNumber}:`, response.status, errorText);
            throw new Error(`Errore batch ${batchNumber}: ${errorText || 'Errore del server'}`);
          }
        } catch (batchError) {
          console.error(`❌ Errore batch ${batchNumber}:`, batchError);

          if (batchError.message.includes('Timeout')) {
            console.error(`⏰ Timeout batch ${batchNumber} dopo 30s`);
            setSendingProgress(`❌ Timeout batch ${batchNumber} - Il server non ha risposto in 30s.`);
            batchErrorMessage = `Timeout al batch ${batchNumber}/${totalBatches}`;
            break;
          }

          batchErrorMessage = `Errore al batch ${batchNumber}/${totalBatches}: ${batchError.message}`;
          break;
        }

      }

      // Risultato finale
      if (allResults.length > 0) {
        // Tutti i job sono stati accodati (modalità asincrona)
        const allAccodati = allResults.every(r => r.accodato);
        if (allAccodati) {
          const totalEmailsAccodati = allResults.reduce((sum, r) => sum + (r.totalEmails || 0), 0);
          const finalResult = {
            accodato:    true,
            jobId:       allResults.length === 1 ? allResults[0].jobId : null,
            servizio:    allResults[0]?.servizio || servizio,
            oggetto:     allResults[0]?.oggetto  || subject,
            dataInvio:   allResults[0]?.dataInvio || new Date().toLocaleString(),
            totalEmails: totalEmailsAccodati,
            inviRiusciti: 0,
            inviFalliti:  0,
            emails: []
          };
          setSendResult(finalResult);
          setSendError(null);
          setSendPartialError(null);
          console.log(`🎉 ${allResults.length} job accodati — ${totalEmailsAccodati} email in background`);
        } else {
        const totalSuccess = allResults.reduce((sum, result) => sum + (result.inviRiusciti || 0), 0);
        const totalErrors = allResults.reduce((sum, result) => sum + (result.inviFalliti || 0), 0);
        const allEmails = allResults.flatMap(r => r.emails || []);

        const completedBatches = allResults.length;
        const noteText = batchErrorMessage
          ? `Invio parziale: ${completedBatches}/${totalBatches} batch completati`
          : `Invio completato in ${completedBatches} batch`;

        const finalResult = {
          servizio: allResults[0]?.servizio || servizio,
          oggetto: allResults[0]?.oggetto || subject,
          dataInvio: allResults[0]?.dataInvio || new Date().toLocaleString(),
          inviRiusciti: totalSuccess,
          inviFalliti: totalErrors,
          note: noteText,
          emails: allEmails
        };

        setSendResult(finalResult);
        setSendError(null);
        setSendPartialError(batchErrorMessage || null);

        if (batchErrorMessage) {
          console.log(`⚠️ Invio parziale: ${totalSuccess} successi, ${totalErrors} errori — ${batchErrorMessage}`);
        } else {
          console.log(`🎉 Invio completato: ${totalSuccess} successi, ${totalErrors} errori`);
        }
        } // chiude else (non-accodato)
      } else if (batchErrorMessage) {
        // Nessun batch completato, solo errore
        setSendResult(null);
        setSendError(batchErrorMessage);
        setSendPartialError(null);
      }

    } catch (error) {
      console.error('❌ Errore durante l\'invio:', error);
      setSendResult(null);
      setSendError(error.message);
      setSendPartialError(null);
    } finally {
      setSending(false);
      setShowSendProgress(false);
      setShowSendResult(true);
      refreshStats();
    }
  };

  // Annullamento invio
  const handleCancelSend = () => {
    setShouldContinue(false);
    setSendingProgress('Annullamento in corso...');
    console.log('🛑 Richiesto annullamento invio');
  };

  // Chiusura modali
  const handleCloseResult = () => {
    const wasAccodato = sendResult?.accodato === true;
    setShowSendResult(false);
    setSendResult(null);
    setSendError(null);
    setSendPartialError(null);
    if (wasAccodato) onSendComplete?.();
  };

  // 🔧 AGGIUNTA: Carica provider SMTP (che mancava)
  const loadProviders = async () => {
    try {
      console.log('🔄 Caricamento provider SMTP...');
      setLoadingProviders(true);
      
      const response = await apiFetch('/api/Provider/ListAll');
      
      if (response.ok) {
        const providersData = await response.json();
        
        console.log('📡 Response provider dal backend:', providersData);
        
        // 🔧 CORREZIONE: La response è direttamente un array, non ha wrapper
        if (Array.isArray(providersData) && providersData.length > 0) {
          const providers = [
            { id: '0', displayName: 'Automatico (Migliore disponibile)' },
            ...providersData.map(p => ({
              id: p.id.toString(),
              displayName: p.displayName // 🔧 Usa direttamente displayName invece di name + description
            }))
          ];
          
          console.log('✅ Provider processati:', providers);
          setAvailableProviders(providers);
          setProvider('0'); // Default automatico
        } else {
          console.warn('⚠️ Array provider vuoto o non valido:', providersData);
          // Fallback con provider di esempio
          setAvailableProviders([
            { id: '0', displayName: 'Automatico (Migliore disponibile)' }
          ]);
          setProvider('0');
        }
      } else {
        console.error('❌ Errore HTTP caricamento provider:', response.status);
        const errorText = await response.text();
        console.error('❌ Dettaglio errore:', errorText);
        
        // Fallback se endpoint non disponibile
        setAvailableProviders([
          { id: '0', displayName: 'Automatico (Migliore disponibile)' },
          { id: '1', displayName: 'Provider 1 (Fallback)' },
          { id: '2', displayName: 'Provider 2 (Fallback)' }
        ]);
        setProvider('0');
      }
    } catch (error) {
      console.error('❌ Errore caricamento provider:', error);
      
      // Fallback completo
      setAvailableProviders([
        { id: '0', displayName: 'Automatico (Migliore disponibile)' },
        { id: '999', displayName: 'Errore caricamento provider' }
      ]);
      setProvider('0');
    } finally {
      setLoadingProviders(false);
    }
  };

  return (
    <div className="mt-4">
      <div className="card border-success">
        {/* HEADER MODIFICATO: titolo a sinistra, badge a destra */}
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
          <h5 className="mb-0 text-success text-start">
            <i className="fas fa-envelope"></i> Composizione Email - {servizio}
          </h5>
          <div className="d-flex gap-2">
            <span className="badge bg-primary">
              <i className="fas fa-users me-1"></i>
              {destinatariCount} destinatari
            </span>
            <span className="badge bg-success">
              <i className="fas fa-envelope me-1"></i>
              {emailCount} email
            </span>
          </div>
        </div>

        <div className="card-body">
          <div className="row">
            {/* COLONNA SINISTRA 8/12 - Contenuto principale */}
            <div className="col-lg-8">
              {/* Sistema Template */}
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0 text-start">
                    <i className="fas fa-file-alt text-primary me-1"></i> <b>Template Email</b>
                  </h6>
                  <div className="btn-group" role="group">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => setShowSaveTemplate(!showSaveTemplate)}
                    >
                      <i className="fas fa-save me-1"></i> Salva Template
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-8">
                    <select
                      className="form-select"
                      value={selectedTemplate}
                      onChange={(e) => {
                        setSelectedTemplate(e.target.value);
                        if (e.target.value) handleLoadTemplate(e.target.value);
                      }}
                    >
                      <option value="">Seleziona un template esistente...</option>
                      {templates.map(template => (
                        <option key={template.id} value={template.id}>
                          {template.name} {template.description && `- ${template.description}`}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    {selectedTemplate && (
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-warning btn-sm"
                          onClick={() => handleUpdateTemplate(selectedTemplate)}
                          title="Sovrascrive oggetto e contenuto del template selezionato con i valori correnti"
                        >
                          <i className="fas fa-sync-alt me-1"></i> Aggiorna
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDeleteTemplate(selectedTemplate)}
                        >
                          <i className="fas fa-trash me-1"></i> Elimina
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* Form salvataggio template */}
                {showSaveTemplate && (
                <div className="mt-3 p-3 border rounded bg-light">
                  <div className="row">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Nome template"
                        value={templateName}
                        onChange={(e) => setTemplateName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Descrizione (opzionale)"
                        value={templateDescription}
                        onChange={(e) => setTemplateDescription(e.target.value)}
                      />
                    </div>
                  </div>
                  
                  {/* 🔧 AGGIUNTO CAMPO CATEGORIA */}
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Categoria (es: Tessere, Solleciti)"
                        value={templateCategory}
                        onChange={(e) => setTemplateCategory(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <select 
                        className="form-select"
                        value={templateTag} 
                        onChange={(e) => setTemplateTag(e.target.value)}
                      >
                        <option value="">Seleziona sezione...</option>
                        <option value="personalizzato">1. Personalizzato</option>
                        <option value="pagamenti">2. Pagamenti</option>
                        <option value="iniziative">3. Iniziative</option>
                        <option value="comunicati">4. Comunicati</option>
                        <option value="scadenzario">5. Scadenzario</option>
                        <option value="rassegna">6. Rassegna</option>
                        <option value="tributi">7. Tributi</option>
                        <option value="generale">Generale (tutte le sezioni)</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="d-flex gap-2">
                    <button className="btn btn-success btn-sm" onClick={async () => {
                      if (!templateName.trim()) {
                        alert('Il nome del template è obbligatorio!');
                        return;
                      }
                      
                      // 🔧 DETERMINA TAG AUTOMATICAMENTE SE NON SELEZIONATO - TUTTE LE 7 SEZIONI
                      let finalTag = templateTag;
                      if (!finalTag) {
                        const currentPath = window.location.pathname;
                        if (currentPath.includes('/personalizzato')) finalTag = 'personalizzato';
                        else if (currentPath.includes('/pagamenti')) finalTag = 'pagamenti';
                        else if (currentPath.includes('/iniziative')) finalTag = 'iniziative';
                        else if (currentPath.includes('/comunicati')) finalTag = 'comunicati';
                        else if (currentPath.includes('/scadenzario')) finalTag = 'scadenzario';
                        else if (currentPath.includes('/rassegna')) finalTag = 'rassegna';
                        else if (currentPath.includes('/tributi')) finalTag = 'tributi';
                        else finalTag = 'generale';
                      }
                      
                      const newTemplate = {
                        id: `template_${Date.now()}`,
                        name: templateName.trim(),
                        description: templateDescription.trim() || '',
                        subject: subject,
                        content: content,
                        category: templateCategory.trim() || 'Generale',
                        tags: finalTag,
                        createdBy: 'user',
                        isActive: true,
                        isShared: true
                      };
                      
                      await saveTemplate(newTemplate);
                      setShowSaveTemplate(false);
                      setTemplateName('');
                      setTemplateDescription('');
                      setTemplateCategory('');
                      setTemplateTag('');
                    }}>
                      <i className="fas fa-check me-1"></i> Salva
                    </button>
                    <button className="btn btn-secondary btn-sm" onClick={() => setShowSaveTemplate(false)}>
                      <i className="fas fa-times me-1"></i> Annulla
                    </button>
                  </div>
                  
                  {/* 🔧 AGGIUNTO STATO PER I NUOVI CAMPI */}
                  <small className="text-muted d-block mt-2">
                    <i className="fas fa-info-circle me-1"></i>
                    Tag suggerito dalla sezione corrente: <strong>{(() => {
                      const currentPath = window.location.pathname;
                      if (currentPath.includes('/personalizzato')) return '1. Personalizzato';
                      if (currentPath.includes('/pagamenti')) return '2. Pagamenti';
                      if (currentPath.includes('/iniziative')) return '3. Iniziative';
                      if (currentPath.includes('/comunicati')) return '4. Comunicati';
                      if (currentPath.includes('/scadenzario')) return '5. Scadenzario';
                      if (currentPath.includes('/rassegna')) return '6. Rassegna';
                      if (currentPath.includes('/tributi')) return '7. Tributi';
                      return 'Generale';
                    })()}</strong>
                  </small>
                </div>
              )}
              </div>

              {/* Oggetto */}
              <div className="mb-3">
                <label className="form-label fw-bold text-start d-block">
                  <i className="fas fa-tag text-primary me-1"></i> Oggetto *
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Inserisci l'oggetto dell'email..."
                  required
                />
              </div>

              {/* Contenuto */}
              <div className="mb-4">
                <label className="form-label fw-bold text-start d-block">
                  <i className="fas fa-edit text-primary me-1"></i> Contenuto *
                </label>
                <Editor
                  ref={editorDomRef}
                  value={content}
                  onEditorChange={(content) => setContent(content)}
                  apiKey='q74sskup0wconaz1nehfn6lwitxbib2iwsggdphgaydyuidk'
                  init={{
                    height: 400,
                    menubar: false,
                    plugins: [
                      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                      'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons'
                    ],
                    toolbar: 'undo redo | blocks fontsize | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist checklist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview | insertfile image media link | code',
                    content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif; font-size: 14px; }',
                    branding: false,
                    language: 'it'
                  }}
                />
              </div>

              {/* 🔧 PLACEHOLDER SEMPRE VISIBILI - GLOBALI + SPECIFICI */}
              {(GLOBAL_PLACEHOLDERS.length > 0 || placeholders.length > 0) && (
                <div className="mb-4">
                  <h6 className="text-start">
                    <i className="fas fa-tags text-info me-1"></i> <b>Segnaposto Disponibili</b>
                  </h6>
                  
                  {/* 🔧 SEZIONE PLACEHOLDER GLOBALI */}
                  <div className="mb-3">
                    <small className="text-muted fw-bold d-block mb-2">
                      <i className="fas fa-globe me-1"></i> Placeholder Globali (sempre disponibili):
                    </small>
                    <div className="d-flex flex-wrap gap-1 mb-2">
                      {GLOBAL_PLACEHOLDERS.map((placeholder, index) => (
                        <button
                          key={`global-${index}`}
                          className="btn btn-outline-success btn-sm"
                          onClick={() => insertPlaceholder(placeholder)}
                          title="Placeholder globale - sempre disponibile"
                        >
                          <i className="fas fa-globe me-1"></i>{placeholder}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* 🔧 SEZIONE PLACEHOLDER SPECIFICI */}
                  {placeholders.filter(p => !GLOBAL_PLACEHOLDERS.includes(p)).length > 0 && (
                    <div className="mb-3">
                      <small className="text-muted fw-bold d-block mb-2">
                        <i className="fas fa-user me-1"></i> Placeholder Specifici (dal file importato):
                      </small>
                      <div className="d-flex flex-wrap gap-1">
                        {placeholders.filter(p => !GLOBAL_PLACEHOLDERS.includes(p)).map((placeholder, index) => (
                          <button
                            key={`specific-${index}`}
                            className="btn btn-outline-info btn-sm"
                            onClick={() => insertPlaceholder(placeholder)}
                            title="Placeholder specifico dal file"
                          >
                            <i className="fas fa-user me-1"></i>{placeholder}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  <small className="text-muted">
                    <i className="fas fa-info-circle me-1"></i>
                    <strong>Globali:</strong> Funzionano sempre (data, immagini ANUTEL).&nbsp; 
                    <strong>Specifici:</strong> Sostituiti con dati dal file importato.
                  </small>
                </div>
              )}
            </div>

            {/* COLONNA DESTRA 4/12 - Opzioni Avanzate */}
            <div className="col-lg-4 border-start pt-4" style={{ backgroundColor: 'aliceblue' }}>
              <div className="mb-4">
                <h6 className="mb-3 text-start">
                  <span className='text-danger'><i className="fas fa-cog text-danger me-1"></i> <b>Opzioni Avanzate</b></span>
                </h6>

                {/* Allegati */}
                <div className="form-check form-switch mb-3 d-flex justify-content-between align-items-center" style={{paddingLeft: 0}} align="left">
                  <label className="form-check-label fw-bold text-start" htmlFor="hasAttachments">
                    <i className="fas fa-paperclip text-warning me-1"></i> 
                    Includi Allegati
                  </label>
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="hasAttachments" 
                    checked={hasAttachments} 
                    onChange={e => setHasAttachments(e.target.checked)} 
                  />
                </div>
                
                {hasAttachments && (
                  <div className="mb-3">
                    {/* Controllo se ci sono tessere o polizze */}
                    {selectedRows && selectedRows.some(row => row.fileUrl && row.fileUrl.startsWith('tessera://')) ? (
                      // Mostra solo info tessere
                      <div className="alert alert-warning py-2 mb-0">
                        <i className="fas fa-file-pdf text-warning me-2"></i>
                        <strong>Modalità Tessera Attiva:</strong>
                        <div className="mt-2">
                          <small className="text-muted d-block">
                            Sono stati rilevati allegati tessera. L'upload di file utente è disabilitato per evitare conflitti.
                          </small>
                          <ul className="mb-0 mt-1">
                            {selectedRows
                              .filter(row => row.fileUrl && row.fileUrl.startsWith('tessera://'))
                              .map((row, idx) => (
                                <li key={idx}>
                                  <code>{row.fileUrl}</code> - {row.ente || 'N/A'}
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    ) : selectedRows && selectedRows.some(row => row.TipoAllegato === 'polizza') ? (
                      // Mostra info polizze
                      <div className="alert alert-info py-2 mb-0">
                        <i className="fas fa-file-pdf text-info me-2"></i>
                        <strong>Allegati Polizza Inclusi:</strong>
                        <div className="mt-2">
                          <small className="text-muted d-block">
                            Verranno allegati automaticamente i seguenti documenti della polizza:
                          </small>
                          <ul className="mb-0 mt-1 small">
                            <li><i className="fas fa-check text-success me-1"></i>Avviso.pdf</li>
                            <li><i className="fas fa-check text-success me-1"></i>Condizioni_Generali.pdf</li>
                            <li><i className="fas fa-check text-success me-1"></i>Polizza.pdf</li>
                            <li><i className="fas fa-check text-success me-1"></i>Statuto_Anutel.pdf</li>
                          </ul>
                        </div>
                      </div>
                    ) : (
                      // Mostra input file normale
                      <>
                        <input type="file" className="form-control" multiple
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                          onChange={handleAttachments} />
                        <div className="form-text">
                          <i className="fas fa-info-circle"></i>
                          Formati supportati: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG (max 10MB per file, 25MB totale)
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* Provider SMTP */}
                <div className="mb-3">
                  <label className="form-label text-start d-block">
                    <i className="fas fa-server text-info me-1"></i> <b>Provider SMTP</b>
                  </label>
                  <select 
                    className="form-select" 
                    value={provider} 
                    onChange={e => setProvider(e.target.value)}
                    disabled={loadingProviders}
                  >
                    {loadingProviders ? (
                      <option>Caricamento...</option>
                    ) : (
                      availableProviders.map(p => (
                        <option key={p.id} value={p.id}>{p.displayName}</option>
                      ))
                    )}
                  </select>
                </div>

                {/* Modalità Test */}
                <div className="form-check form-switch mb-3 d-flex justify-content-between align-items-center" style={{paddingLeft: 0}} align="left">
                  <label className="form-check-label fw-bold text-start" htmlFor="testMode">
                    <i className="fas fa-flask text-danger me-1"></i> 
                    Modalità Test
                  </label>
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="testMode" 
                    checked={testMode} 
                    onChange={e => setTestMode(e.target.checked)} 
                  />
                </div>
                
                {testMode && (
                  <div className="mb-3">
                    <input 
                      type="text" 
                      className="form-control" 
                      placeholder="email1@test.com, email2@test.com"
                      value={testEmails}
                      onChange={e => setTestEmails(e.target.value)}
                    />
                    <div className="form-text">
                      <i className="fas fa-info-circle"></i>
                      Inserisci gli indirizzi email separati da virgola per il test
                    </div>
                  </div>
                )}

                {/* Copia CC */}
                <div className="form-check form-switch mb-3 d-flex justify-content-between align-items-center" style={{paddingLeft: 0}} align="left">
                  <label className="form-check-label fw-bold text-start" htmlFor="sendCopy">
                    <i className="fas fa-copy text-info me-1"></i> 
                    Invia copia in CC
                  </label>
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="sendCopy" 
                    checked={sendCopy} 
                    onChange={e => setSendCopy(e.target.checked)} 
                  />
                </div>
                
                {sendCopy && (
                  <div className="mb-3">
                    <input 
                      type="text" 
                      className="form-control" 
                      placeholder="admin@anutel.it, segreteria@anutel.it"
                      value={copyEmails}
                      onChange={e => setCopyEmails(e.target.value)}
                    />
                    <div className="form-text">
                      <i className="fas fa-info-circle"></i>
                      Inserisci gli indirizzi email che riceveranno una copia, separati da virgola
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>

          {/* PULSANTI CENTRATI SOTTO ENTRAMBE LE COLONNE */}
          <div className="row">
            <div className="col-12">
              <div className="d-flex gap-2 justify-content-center pt-3 border-top">
                <button 
                  className="btn btn-outline-info"
                  onClick={() => setShowPreview(true)}
                  disabled={!subject.trim() || !content.trim()}
                >
                  <i className="fas fa-eye me-1"></i> Anteprima
                </button>
                <button 
                  className="btn btn-success"
                  onClick={handleSendEmailInBatches}
                  disabled={sending || !subject.trim() || !content.trim()}
                >
                  {sending ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Invio in corso...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane me-1"></i> 
                      Invia Email {testMode ? '(TEST)' : ''}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modali */}
      <PreviewModal
        show={showPreview}
        onClose={() => setShowPreview(false)}
        subject={subject}
        content={content}
        provider={availableProviders.find(p => p.id == provider)?.displayName || 'Automatico'}
        testMode={testMode}
        testEmails={testEmails}
        sendCopy={sendCopy}
        copyEmails={copyEmails}
        attachments={attachments}
        emailCount={emailCount}
      />

      <SendProgressModal
        show={showSendProgress}
        onClose={() => setShowSendProgress(false)}
        onCancel={handleCancelSend}
        progress={sendingProgress}
        sending={sending}
      />

      <SendResultModal
        show={showSendResult}
        onClose={handleCloseResult}
        result={sendResult}
        error={sendError}
        partialError={sendPartialError}
      />
    </div>
  );
}

export default ComposizioneMail;